import { KeyValue } from "@angular/common";
import { DevOpsActionParameter } from "./DevOpsActionParameter";

export class DevOpsActionAndParameter {
    actionName?: string;
    actionScope?: string;
    actionKind?: string;
    parameters?: KeyValue<string, DevOpsActionParameter[]>[];
    isParametersSupported?: boolean;
    isEnabled?: boolean;
}


